export default {
  root: {
    class: [
      'rounded bg-surface-50 dark:bg-surface-950'
    ]
  },
  toolbar: {
    class: [
      'rounded-tr rounded-tl'
    ]
  },
  toolbarButton: {
    class: [
      
    ]
  },
  toolbarPicker: {
    class: [
      
    ]
  },
  toolbarPickerLabel: {
    class: [

    ]
  },
  content: ({ props }) => {
    return ({
      class: [
        // Custom
        'browser-default',

        // Font
        'leading-none text-base font-light not-italic',

        // Spacing
        'min-h-[84px]',
        'm-0',
        'py-2 px-3',

        // Shape
        'rounded-br rounded-bl',

        // Colors
        'text-surface-800 dark:text-white/80',
        'placeholder:text-surface-400 dark:placeholder:text-surface-500',
        { 'bg-surface-50 dark:bg-surface-950': !props.disabled },
        'border',
        { 'border-surface-300 dark:border-surface-600': !props.invalid },

        // Invalid State
        'invalid:focus:ring-red-200',
        'invalid:hover:border-red-500',
        { 'border-red-500 dark:border-red-400': props.invalid },

        // States
        {
          'hover:border-surface-400 dark:hover:border-surface-600': !props.disabled && !props.invalid,
          'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:z-10': !props.disabled,
          'text-surface-800/60 bg-surface-200 dark:bg-surface-700 select-none pointer-events-none cursor-default': props.disabled
        },

        // Misc
        'appearance-none',
        'transition-colors duration-200'
      ]
    })
  },
  placeholder: {
    class: [
      
    ]
  },
  focus: {
    class: [
      
    ]
  },
  textStyles: {
  },
  transition: {
   
  }
}
